// extracted by mini-css-extract-plugin
export default {"wrapper":"Administration_wrapper__s07xA","flashMessage":"Administration_flashMessage__cHiVt"};